const PaymentTypeEnum = {
  CASH: 1,
  BANK_TRANSFER: 2,
  WALLET: 3,
  CARD: 4,
  OTHER: 5
}
// Reference to ReceiptTypeEnum
export default PaymentTypeEnum


// WEBPACK FOOTER //
// ./src/enum/paymentTypeEnum.js